export const richTextAsPlainText = (richText: string) => {
  const container = document.createElement('div');
  container.innerHTML = richText
    .replaceAll('<br>', '\n')
    .replaceAll(/&nbsp;/g, ' ')
    .replaceAll('</p>', '</p>\n')
    .replaceAll('</div>', '</div>\n');
  return container.textContent || container.innerText || '';
};
